import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import get from 'lodash.get'

export const getTranslations = gql`
  query {
    translations(limit: 999999, page: 1) {
      key
      value
      locale
    }
  }
`

export const getTranslationsOptions = {
  props: (props) => ({
    ...props,
    getTranslations(language = 'en-US') {
      if (props.data.loading) {
        return {}
      }

      let translations = get(props.data, 'translations', []).filter(t => t.locale === language)

      return translations.reduce((object, value) => {
        object[value.key] = value.value
        return object
      }, {})
    }
  })
}

export default graphql(getTranslations, getTranslationsOptions)



// WEBPACK FOOTER //
// ./src/components/pages/App/App.getTranslation.js